import { BaseDto } from "src/dtos/common/baseDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface PrdInspectResultDto extends BaseDto {
	inspectNo: string;              // 검사결과순번(기본키)
	inspectDt: string | undefined;        // 검사일자
	compCd: string;                 // 사업장
	inspectType: string;            // 검사유형
	inspectorEmp: string;           // 검사자
	supplierCustom: string;         // 공급자 - 거래처
	supplierCustomNm?: string;      // 공급자명 - 거래처명
	workplaceCd: string;            // 공정코드
	workplaceNm?: string;           // 공정명
	jobTeam: string;                // 작업팀
	itemCd: string;                 // 품목코드
	workerEmp: string;              // 작업자
	workerEmpNm?: string;           // 작업자명
	inspectQty: number;             // 검사량
	badQty: number;                 // 불량수량
	acceptQty: number;              // 검수(합격)량
	badCase: string;                // 불량원인코드
	badCaseNm?: string;             // 불량원인코드명
	basOrderNo: string;             // 주문번호(생산실적번호)
	basOrderItemno: string;         // 주문상품번호(생산실적의 수불정보에 있는 itemNo)
	basLotNo: string;               // 로트번호(생산실적시 발행한 lotNo)
	lotNo?: string;                 // 로트번호(생산실적시 발행한 lotNo)
	remark: string;                 // 비고

	inserted: boolean;
	isModified: boolean;
}

export const defaultPrdInspectResultDto: PrdInspectResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: '',
	inspectDt: formatDate(new Date()),
	compCd: '',
	inspectType: '',
	inspectorEmp: '',
	supplierCustom: '',
	supplierCustomNm: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	workerEmp: '',
	workerEmpNm: '',
	inspectQty: 0,
	badQty: 0,
	acceptQty: 0,
	badCase: '',
	badCaseNm: '',
	basOrderNo: '',
	basOrderItemno: '',
	basLotNo: '',
	lotNo: '',
	remark: '',

	inserted: false,
	isModified: false,
};
